// extracted by mini-css-extract-plugin
export var modal = "pop-up-module--modal--88d41";